import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { auth, db } from '../firebase';
import {
  doc,
  onSnapshot,
  updateDoc,
  collection,
  addDoc,
  Timestamp
} from 'firebase/firestore';
import { useOrganization } from '../context/OrganizationContext';

const ModulosActivos = () => {
  const { t } = useTranslation('billing');
  const { context } = useOrganization();
  const [extrasActivos, setExtrasActivos] = useState({});
  const [extrasCancelar, setExtrasCancelar] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!auth.currentUser) return;

    const basePath = context.mode === 'organization' && context.orgId
      ? `organizations/${context.orgId}`
      : `clientes/${auth.currentUser.uid}`;
    const ref = doc(db, basePath);
    const unsubscribe = onSnapshot(ref, (docSnap) => {
      if (docSnap.exists()) {
        const data = docSnap.data();
        setExtrasActivos(data.extrasActivos || {});
        setExtrasCancelar(data.extrasCancelar || {});
        setLoading(false);
      }
    });

    return () => unsubscribe();
  }, [context]);

  const handleToggleCancel = async (nombreModulo, estaCancelado) => {
    const confirmacion = window.confirm(
      estaCancelado
        ? t('modules.confirmReactivate')
        : t('modules.confirmCancel')
    );

    if (!confirmacion) return;

    const basePath = context.mode === 'organization' && context.orgId
      ? `organizations/${context.orgId}`
      : `clientes/${auth.currentUser.uid}`;
    const ref = doc(db, basePath);
    const nuevosExtrasCancelar = { ...extrasCancelar };

    const accion = estaCancelado ? 'reactivado' : 'marcado_para_cancelar';
    const mensaje = `El módulo "${nombreModulo}" fue ${estaCancelado ? 'reactivado' : 'marcado para cancelación'} por el cliente.`;

    if (estaCancelado) {
      delete nuevosExtrasCancelar[nombreModulo];
    } else {
      nuevosExtrasCancelar[nombreModulo] = true;
    }

    await updateDoc(ref, {
      extrasCancelar: nuevosExtrasCancelar
    });

    // Registrar acción en el log
    const logRef = collection(ref, 'log');
    // 🚨 IMPORTANT: All resources MUST include organizationId field for Firestore security rules
    await addDoc(logRef, {
      tipo: 'modulo',
      modulo: nombreModulo,
      accion,
      descripcion: mensaje,
      timestamp: Timestamp.now(),
      uid: auth.currentUser.uid,
      organizationId: context.mode === 'organization' ? context.orgId : null,
    });
  };

  if (loading) return <p>{t('modules.loading')}</p>;

  const modulos = Object.entries(extrasActivos);
  const hayModulosMarcadosParaCancelar = Object.keys(extrasCancelar).length > 0;

  if (modulos.length === 0) {
    return <p>{t('modules.noActiveModules')}</p>;
  }

  return (
    <div>
      <h3>{t('modules.title')}</h3>

      {/* 🔔 Alerta visual si hay módulos marcados para cancelar */}
      {hayModulosMarcadosParaCancelar && (
        <div style={{
          backgroundColor: '#fff3cd',
          border: '1px solid #ffeeba',
          padding: '12px',
          marginBottom: '16px',
          borderRadius: '4px',
          color: '#856404'
        }}>
          <strong>{t('modules.warningTitle')}</strong> {t('modules.warningBody')}
        </div>
      )}

      <table style={{ width: '100%', borderCollapse: 'collapse' }}>
        <thead>
          <tr>
            <th style={{ textAlign: 'left', padding: '8px' }}>{t('modules.headerModule')}</th>
            <th style={{ textAlign: 'left', padding: '8px' }}>{t('modules.headerStatus')}</th>
            <th style={{ padding: '8px' }}>{t('modules.headerAction')}</th>
          </tr>
        </thead>
        <tbody>
          {modulos.map(([nombre, datos]) => {
            const estaCancelado = extrasCancelar[nombre] === true;

            return (
              <tr key={nombre} style={{ borderBottom: '1px solid #ccc' }}>
                <td style={{ padding: '8px' }}>{nombre}</td>
                <td style={{ padding: '8px' }}>
                  {estaCancelado ? t('modules.statusPendingCancel') : t('modules.statusActive')}
                </td>
                <td style={{ padding: '8px' }}>
                  <button
                    onClick={() => handleToggleCancel(nombre, estaCancelado)}
                    style={{
                      backgroundColor: estaCancelado ? '#4caf50' : '#e53935',
                      color: '#fff',
                      padding: '6px 12px',
                      border: 'none',
                      borderRadius: '4px',
                      cursor: 'pointer'
                    }}
                  >
                    {estaCancelado ? t('modules.reactivate') : t('modules.cancel')}
                  </button>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default ModulosActivos;